<template>
    <div v-if="isAdmin">
        <button class="btn btn-primary" @click="regenerateBetPeriod">Tippschein mit neuen Spielen berechnen</button>
    </div>
</template>

<script>
import sakaliApi from "@/sakali-api";

export default {
    props: {
        betPeriodId: Number
    },
    data() {
        return {
            isAdmin: false
        }
    },
    watch: {
        betPeriodId: {
            handler(newVal, oldVal) {
                if (newVal !== oldVal)
                    sakaliApi.get(`/admin`)
                        .then(() => this.isAdmin = true)
                        .catch(() => this.isAdmin = false)
            },
            immediate: true
        }
    },
    methods: {
        regenerateBetPeriod() {
            sakaliApi.post('/admin/commands/startBetPeriod?bp=' + this.betPeriodId)
        }
    }
}
</script>
